export type Appearance = "system" | "light" | "dark";

const appearanceKey = "base-sul-os:appearance";

export function loadAppearance(): Appearance {
  const value = localStorage.getItem(appearanceKey);
  return value === "light" || value === "dark" ? value : "system";
}

export function applyAppearance(appearance: Appearance): void {
  if (appearance === "system") document.documentElement.removeAttribute("data-theme");
  else document.documentElement.dataset.theme = appearance;
}

export function saveAppearance(appearance: Appearance): void {
  if (appearance === "system") localStorage.removeItem(appearanceKey);
  else localStorage.setItem(appearanceKey, appearance);
  applyAppearance(appearance);
}
